import React, { useRef, useEffect } from "react";
import { BOTTOM_PANE_COLORS } from "../theme";

// 下部ペイン: 音楽情報の描画コンポーネント
const BottomPaneRenderer = ({
  data,
  onBottomClick,
  width,
  height,
  isMuted,
}) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");

    // 固定の背景色を使用（ActionBar/StatusBarと同じ色）
    ctx.fillStyle = "#111827"; // STATUS_BAR_COLORS.backgroundと同じ
    ctx.fillRect(0, 0, width, height);

    // パターンの描画部分
    const patternStartX = width * 0.15;
    const patternWidth = width * 0.7;
    const stepWidth = patternWidth / 16;

    // 上下の余白を設定
    const paddingVertical = height * 0.25; // 上下それぞれ25%の余白

    data.pattern.forEach((step, i) => {
      const [noteIdx, vol] = step;
      const isCurrent = !isMuted && i === data.step;
      ctx.fillStyle = isCurrent
        ? BOTTOM_PANE_COLORS.text
        : BOTTOM_PANE_COLORS.stepInactive;

      // 使用可能な高さから余白を引いた範囲で描画
      const availableHeight = height - paddingVertical * 2;
      const maxHeight = availableHeight * 0.8; // 利用可能な高さの80%を最大に
      const minHeight = availableHeight * 0.1; // 最小高さ

      const rectHeight = isMuted
        ? minHeight
        : noteIdx !== -1
        ? minHeight + vol * data.master_volume * maxHeight
        : minHeight;

      // 描画位置を調整（上部の余白を考慮）
      const rectY = paddingVertical + availableHeight / 2 - rectHeight / 2;

      ctx.fillRect(
        patternStartX + i * stepWidth,
        rectY,
        stepWidth * 0.8,
        rectHeight
      );
    });
  }, [data, width, height, isMuted]);

  return (
    <canvas
      ref={canvasRef}
      width={width}
      height={height}
      className="block w-full h-full cursor-pointer"
      onClick={onBottomClick}
    />
  );
};

export default BottomPaneRenderer;
